import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { BookOpen, Heart, Users, ArrowLeft } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AboutPage() {
  const [page, setPage] = useState(null);

  useEffect(() => {
    axios.get(`${API}/cms/about`).then(r => setPage(r.data.content)).catch(() => {});
  }, []);

  if (!page) return <div className="min-h-screen bg-[#F9F8F6] flex items-center justify-center text-[#475569]">Loading...</div>;

  return (
    <div className="min-h-screen bg-[#F9F8F6]" data-testid="about-page">
      {/* Header */}
      <header className="bg-white border-b border-[#E2DFD8]">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <span className="text-lg font-bold text-[#3D3229] tracking-wide uppercase" style={{fontFamily:"'Nunito', 'Quicksand', sans-serif", letterSpacing:'0.12em'}}>dsashun</span>
          </Link>
          <Link to="/" className="flex items-center gap-2 text-sm text-[#475569] hover:text-[#1B3A6B]">
            <ArrowLeft className="w-4 h-4" /> Back
          </Link>
        </div>
      </header>

      {/* Hero */}
      <section className="py-20 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="font-heading text-4xl sm:text-5xl font-bold text-[#0F1A2A] mb-6" data-testid="about-title">{page.title}</h1>
          <p className="text-lg text-[#475569] leading-relaxed">{page.mission}</p>
        </div>
      </section>

      {/* Image */}
      {page.image_url && (
        <section className="px-6 pb-12">
          <div className="max-w-4xl mx-auto">
            <img src={page.image_url} alt="About" className="w-full rounded-2xl shadow-lg object-cover max-h-96" data-testid="about-image" />
          </div>
        </section>
      )}

      {/* Story */}
      <section className="py-12 px-6 bg-white">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading text-2xl font-bold text-[#1B3A6B] mb-6">Our Story</h2>
          <p className="text-[#475569] leading-relaxed text-base">{page.story}</p>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl font-bold text-[#1B3A6B] mb-8 text-center">Our Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {(page.values || []).map((v, i) => (
              <div key={i} className="bg-white rounded-2xl p-6 shadow-sm">
                <div className="w-10 h-10 rounded-xl bg-[#B8860B]/10 flex items-center justify-center mb-4">
                  <Heart className="w-5 h-5 text-[#B8860B]" strokeWidth={1.5} />
                </div>
                <h3 className="font-heading text-base font-bold text-[#0F1A2A] mb-2">{v.title}</h3>
                <p className="text-sm text-[#475569]">{v.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Disclaimer */}
      <section className="py-12 px-6 bg-[#1B3A6B]">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-white/90 text-base leading-relaxed italic">
            "This platform is a tool — a guide to assist, not replace, the diligent, prayer-filled, Spirit-led preparation that every ministry deserves. Let the Spirit lead; let this tool serve."
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0F1A2A] text-white/60 py-8 px-6">
        <div className="max-w-6xl mx-auto text-center text-sm">
          &copy; {new Date().getFullYear()} dsashun. All rights reserved. | <Link to="/" className="hover:text-white">Home</Link> | <Link to="/support" className="hover:text-white">Support</Link> | <Link to="/contact" className="hover:text-white">Contact</Link>
        </div>
      </footer>
    </div>
  );
}
